"use client";

import { AuthProvider } from "@/components/AuthContext";
import { CouponTracker } from "@/components/CouponTracker";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { GuestSessionClaimCoordinator } from "@/components/GuestSessionClaimCoordinator";
import { PaywallExitRecoveryHost } from "@/components/paywall/PaywallExitRecoveryHost";
import { VersionUpdater } from "@/components/system/VersionUpdater";
import { AppDataProvider } from "@/contexts/AppDataContext";
import { setupGlobalErrorHandlers } from "@/lib/errorTracking";
import { logPrerenderBreadcrumb } from "@/lib/prerender-diagnostics";
import dynamic from "next/dynamic";
import { useEffect } from "react";
import { PostHogProvider } from "./providers";

const PWAInstallPromptSimple = dynamic(() => import("@/components/PWAInstallPromptSimple"), {
  ssr: false,
});

logPrerenderBreadcrumb("app/RootClientShell module evaluated", {
  hasWindow: typeof window !== "undefined",
  hasDocument: typeof document !== "undefined",
});

export function RootClientShell({ children }: { children: React.ReactNode }) {
  logPrerenderBreadcrumb("RootClientShell render start", {
    hasWindow: typeof window !== "undefined",
    hasDocument: typeof document !== "undefined",
  });

  useEffect(() => {
    setupGlobalErrorHandlers();
  }, []);

  return (
    <>
      <VersionUpdater />
      <ErrorBoundary>
        <AuthProvider>
          <AppDataProvider>
            <PostHogProvider>
              <GuestSessionClaimCoordinator />
              <CouponTracker />
              {children}
              <PaywallExitRecoveryHost />
              <PWAInstallPromptSimple />
            </PostHogProvider>
          </AppDataProvider>
        </AuthProvider>
      </ErrorBoundary>
    </>
  );
}
